
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: 'ShareFeedbackPage',
}) 
export default class ShareFeedbackPage extends Vue {
}
